module.exports = __webpack_public_path__ + "assets/yandex.f385ff3e.svg";